export default "__VITE_ASSET__DsmJXi68__"